<template>
  <div style="height: 100%" ></div>
</template>
<script>
import { NavBar, Image, Button, Toast } from "vant";
import MallServiceApi from "@/api/mall";
import { getUrlParams } from "@/utils/utility";
import {
  connectWebViewJavascriptBridge,
  getBrowserUserAgent,
} from "@/utils/utility";
var userAgent = getBrowserUserAgent();
var dsBridge = require("dsbridge");
import inobounce from "inobounce";
var picHost = process.env.VUE_APP_PIC_BASE_URL;
export default {
  components: {
    [NavBar.name]: NavBar,
    [Image.name]: Image,
    [Button.name]: Button,
    [Toast.name]: Toast,
  },

  data() {
    return {
      indexStr: "",
      theme:1
    };
  },

  mounted() {},
  activated() {
    this.theme = sessionStorage.getItem("theme");
  },
  created() {
    this.indexStr = this.$route.query.indexStr;
    this.proInfoKey();
  },
  methods: {
    proInfoKey() {
      let params = { indexStr: this.indexStr };
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        loadingType: "spinner",
      });
      MallServiceApi.proInfoKey(params).then((res) => {
        // Toast.clear();
        if (res.code == 200) {
          this.$router.replace({
            path: "/product_info",
            query: { type: res.data.productCategoryId, id: res.data.productId },
          });
        }
      });
    },
  },
};
</script>
<style lang='less' scoped>
.white {
  background: #eeeff4;
  color: #333;
  .sub-boot {
    background: #fff;
  }
}
.black {
  color: #676d78;
  background: #121620;

  .sub-boot {
    background: #171c27;
    color: #f0f1f4;
  }
}
.product-desp {
  // padding: 0 16px;
  ::v-deep {
    img,
    p,
    span {
      width: 100% !important;
      height: auto !important;
      padding: 0px !important;
    }
  }
}

.sub-boot {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 10px;
  text-align: center;
}

.product-main {
  position: absolute;
  overflow: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.product-info {
  margin: 10px 0;
}

.product-info .title {
  text-align: center;
}

.product-info .summary {
  text-align: center;
  font-size: 12px;
}

.sub-boot .agreement {
  display: block;
  height: 25px;
  line-height: 25px;
  text-align: center;
  font-size: 12px;
}
.textColor {
  /deep/.van-nav-bar__title {
    color: #333 !important;
  }
  /deep/.van-icon {
    color: #333;
  }
}
.textColor1 {
  /deep/.van-nav-bar__title {
    color: #fff !important;
  }
  /deep/.van-icon {
    color: #fff !important;
  }
}
.search {
  height: 1.57rem;
  /deep/.van-nav-bar .van-icon {
    color: #000000;
  }
}
</style>